import React from "react";
import { TextField as MTextField } from "@material-ui/core";
import styled from "@emotion/styled";

import { Error } from "../layout/Error";

const MuiTextField = styled(MTextField)`
  // Change placeholder color
  & ::placeholder {
    color: #000 !important;
    opacity: 1 !important;
    fzont-size: 14px;
  }
`;

export const TextField = ({ fieldProps, children, ...props }) => {
  const {
    fieldState: { isTouched, error },
  } = fieldProps;
  const { field } = fieldProps;

  return (
    <>
      <MuiTextField
        inputRef={field.ref}
        onChange={field.onChange}
        value={field.value}
        error={isTouched && error}
        {...props}
      >
        {children}
      </MuiTextField>
      {error && <Error>{error.message}</Error>}
    </>
  );
};
